﻿import {HTMLInputAutoCompleteAttribute, JSX} from "react";
import {MvvmTextControlProps} from "./MvvmControlProps";
import MvvmInput from "./MvvmInput";

const textToString = (value: string | undefined): string => value ?? "";
const textFromString = (value: string | undefined): string => value ?? "";

export type MvvmTextInputType =
	"text"
	| "color"
	| "email"
	| "month"
	| "password"
	| "search"
	| "tel"
	| "url"
	| "week";

export interface MvvmTextInputProps<T extends object = never> extends MvvmTextControlProps<T, string> {
	type: MvvmTextInputType;
	minLength?: number;
	maxLength?: number;
	autoComplete?: HTMLInputAutoCompleteAttribute;
	autoCapitalize?: "off" | "none" | "on" | "sentences" | "words" | "characters" | undefined | string & {};
	enterKeyHint?: "enter" | "done" | "go" | "next" | "previous" | "search" | "send" | undefined;
	inputMode?: "none" | "text" | "tel" | "url" | "email" | "numeric" | "decimal" | "search" | undefined;
	list?: string;
	validateOnChange?: boolean;
}

// Types whose native pickers commit whole values at once, so each change is a real edit.
const updateOnChangeTypes = new Set<string>(["color", "month", "week"]);

export default function MvvmTextInput<T extends object = never>(props: MvvmTextInputProps<T>): JSX.Element {
	return <MvvmInput<T, string> control={props}
	                             type={props.type}
	                             updateOnChange={props.validateOnChange ?? updateOnChangeTypes.has(props.type)}
	                             maxLength={props.maxLength}
	                             minLength={props.minLength}
	                             autoComplete={props.autoComplete}
	                             autoCapitalize={props.autoCapitalize}
	                             enterKeyHint={props.enterKeyHint}
	                             inputMode={props.inputMode}
	                             list={props.list}
	                             valueToString={textToString}
	                             valueFromString={textFromString}/>;
};
